import React from 'react'

const MigratedApplicationMessage = () => {
    return (
        <div className="migrated-application-message">
            <h1>This application is migrated to a new location.</h1>
            <p>
                Please visit MQA Online Services to fill out an application.
            </p>
            <button
                onClick={() => window.location.href = 'https://mqa-vo.doh.state.fl.us/'}
                className="redirect-button"
            >
                MQA Online Services
            </button>
        </div>

    )
}

export default MigratedApplicationMessage